"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VrmCheckOutcome = void 0;
var VrmCheckOutcome;
(function (VrmCheckOutcome) {
    VrmCheckOutcome["MATCHED"] = "MATCHED";
    VrmCheckOutcome["NOT_MATCHED"] = "NOT_MATCHED";
    VrmCheckOutcome["UNABLE_TO_ASSESS"] = "UNABLE_TO_ASSESS";
})(VrmCheckOutcome = exports.VrmCheckOutcome || (exports.VrmCheckOutcome = {}));
